/**
 * This code was  originally copied from the lexical playground source code on github
 * And so it doesn't follow our code style
 * https://github.com/facebook/lexical/tree/main/packages/lexical-playground
 *
 */

import { isContractValidationPage, isSetupPage } from "helpers/utils";
import { t } from "i18next";
import type {
    DOMConversionMap,
    DOMConversionOutput,
    DOMExportOutput,
    EditorConfig,
    LexicalNode,
    SerializedElementNode,
} from "lexical";
import { ElementNode } from "lexical";

type SerializedConditionalContentNode = SerializedElementNode;

export function convertConditionalContentElement(domNode: HTMLElement): DOMConversionOutput | null {
    const node = $createConditionalContentNode();
    return {
        node,
    };
}

export class ConditionalContentNode extends ElementNode {
    static getType(): string {
        return "conditional-content";
    }

    static clone(node: ConditionalContentNode): ConditionalContentNode {
        return new ConditionalContentNode(node.__key);
    }

    createDOM(config: EditorConfig): HTMLElement {
        const dom = document.createElement("div");
        dom.classList.add("Conditional__content");
        if (!isContractValidationPage()) {
            dom.setAttribute("data-content", t("RichEditor.OptionalBlock"));
        }
        return dom;
    }

    updateDOM(prevNode: ConditionalContentNode, dom: HTMLElement): boolean {
        return false;
    }

    static importDOM(): DOMConversionMap | null {
        return {
            div: (domNode: HTMLElement) => {
                if (!domNode.hasAttribute("data-lexical-conditional-content")) {
                    return null;
                }
                return {
                    conversion: convertConditionalContentElement,
                    priority: 2,
                };
            },
        };
    }

    exportDOM(): DOMExportOutput {
        const element = document.createElement("div");
        element.setAttribute("data-lexical-conditional-content", "true");
        return { element };
    }

    static importJSON(serializedNode: SerializedConditionalContentNode): ConditionalContentNode {
        return $createConditionalContentNode();
    }

    isShadowRoot(): boolean {
        return true;
    }

    exportJSON(): SerializedConditionalContentNode {
        return {
            ...super.exportJSON(),
            type: "conditional-content",
            version: 1,
        };
    }
}

export function $createConditionalContentNode(): ConditionalContentNode {
    return new ConditionalContentNode();
}

export function $isConditionalContentNode(node: LexicalNode | null | undefined): node is ConditionalContentNode {
    return node instanceof ConditionalContentNode;
}
